import { render, staticRenderFns } from "./StatisticNamu.vue?vue&type=template&id=6850a952"
import script from "./StatisticNamu.vue?vue&type=script&lang=js"
export * from "./StatisticNamu.vue?vue&type=script&lang=js"
import style0 from "./StatisticNamu.vue?vue&type=style&index=0&id=6850a952&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports